
export const detectPriceConstraints = (searchTerms: string[]) => {
  const constraints: { maxPrice?: number; minPrice?: number; budgetType?: string } = {};
  
  // Join terms to handle multi-word price expressions
  const fullQuery = searchTerms.join(' ').toLowerCase();
  
  // Budget indicators
  const budgetKeywords = ['goedkoop', 'budget', 'voordelig', 'betaalbaar', 'goedkope', 'budgetvriendelijk'];
  const luxuryKeywords = ['luxe', 'duur', 'premium', 'high-end', 'exclusief'];
  
  // Detect specific price ranges
  const euroMatches = fullQuery.match(/€\s*(\d+)/g);
  const maxMatches = fullQuery.match(/max(?:imaal)?\s*€?\s*(\d+)/g);
  const onderMatches = fullQuery.match(/onder\s*(?:de\s*)?€?\s*(\d+)/g);
  
  // Extract specific prices
  if (euroMatches) {
    euroMatches.forEach(match => {
      const price = parseInt(match.replace(/[€\s]/g, ''));
      if (price > 0) {
        if (fullQuery.includes('max') || fullQuery.includes('onder')) {
          constraints.maxPrice = price;
        } else {
          // If no clear indication, treat as max price for budget searches
          constraints.maxPrice = price;
        }
      }
    });
  }
  
  if (maxMatches) {
    maxMatches.forEach(match => {
      const price = parseInt(match.replace(/[^\d]/g, ''));
      if (price > 0) {
        constraints.maxPrice = price;
      }
    });
  }
  
  if (onderMatches) {
    onderMatches.forEach(match => {
      const price = parseInt(match.replace(/[^\d]/g, ''));
      if (price > 0) {
        constraints.maxPrice = price;
      }
    });
  }
  
  // Budget type detection
  if (budgetKeywords.some(keyword => fullQuery.includes(keyword))) {
    constraints.budgetType = 'budget';
    // Set reasonable budget max if no specific price mentioned
    if (!constraints.maxPrice) {
      constraints.maxPrice = 500; // Default budget max
    }
  }
  
  if (luxuryKeywords.some(keyword => fullQuery.includes(keyword))) {
    constraints.budgetType = 'luxury';
    // Set minimum for luxury if no specific price mentioned
    if (!constraints.minPrice) {
      constraints.minPrice = 1000; // Default luxury min
    }
  }
  
  return Object.keys(constraints).length > 0 ? constraints : null;
};

export const applyPriceFilter = (dbQuery: any, priceConstraints: any) => {
  if (!priceConstraints) return dbQuery;
  
  console.log('Applying price constraints:', priceConstraints);
  
  if (priceConstraints.maxPrice) {
    dbQuery = dbQuery.lte('price', priceConstraints.maxPrice);
  }
  
  if (priceConstraints.minPrice) {
    dbQuery = dbQuery.gte('price', priceConstraints.minPrice);
  }
  
  return dbQuery;
};
